import { buttonMode } from './button';
import { selectMode } from './select';

export const modes = {
  'button': buttonMode,
  'select': selectMode
}
